import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { I18nProvider } from "@/lib/i18n";
import { AuthProvider } from "@/lib/auth";
import { B2BAuthProvider } from "@/lib/b2bAuth";
import { CookieProvider } from "@/lib/cookies";

import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import HumanLinePage from "@/pages/HumanLinePage";
import ScienceQualityPage from "@/pages/ScienceQualityPage";
import AboutPage from "@/pages/AboutPage";
import JournalPage from "@/pages/JournalPage";
import ArticlePage from "@/pages/ArticlePage";
import FAQPage from "@/pages/FAQPage";
import B2BPage from "@/pages/B2BPage";
import ContactPage from "@/pages/ContactPage";
import { PrivacyPage, CookiePage, TermsPage, AccessibilityPage } from "@/pages/LegalPages";
import NewsletterConfirmPage from "@/pages/NewsletterConfirmPage";
import NotFoundPage from "@/pages/NotFoundPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboard";
import B2BLoginPage, { B2BRequestAccessPage, B2BForgotPasswordPage, B2BSetPasswordPage } from "@/pages/B2BLoginPage";
import B2BDashboardPage from "@/pages/B2BDashboardPage";

import "@/App.css";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <B2BAuthProvider>
          <CookieProvider>
            <BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<HomePage />} />
                <Route path="prodotti" element={<ProductsPage />} />
                <Route path="prodotti/pet/:slug" element={<ProductDetailPage />} />
                <Route path="prodotti/human/:slug" element={<ProductDetailPage />} />
                <Route path="prodotti/:slug" element={<ProductDetailPage />} />
                <Route path="linea-human" element={<HumanLinePage />} />
                <Route path="scienza-qualita" element={<ScienceQualityPage />} />
                <Route path="chi-siamo" element={<AboutPage />} />
                <Route path="journal" element={<JournalPage />} />
                <Route path="journal/:slug" element={<ArticlePage />} />
                <Route path="faq" element={<FAQPage />} />
                <Route path="professionisti" element={<B2BPage />} />
                <Route path="contatti" element={<ContactPage />} />
                <Route path="privacy" element={<PrivacyPage />} />
                <Route path="cookie" element={<CookiePage />} />
                <Route path="termini" element={<TermsPage />} />
                <Route path="accessibilita" element={<AccessibilityPage />} />
                <Route path="newsletter/confirm" element={<NewsletterConfirmPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboardPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
              <Route path="/area-b2b" element={<B2BLoginPage />} />
              <Route path="/area-b2b/richiedi-accesso" element={<B2BRequestAccessPage />} />
              <Route path="/area-b2b/recupera-password" element={<B2BForgotPasswordPage />} />
              <Route path="/area-b2b/imposta-password" element={<B2BSetPasswordPage />} />
              <Route path="/area-b2b/dashboard" element={<B2BDashboardPage />} />
            </Routes>
          </BrowserRouter>
        </CookieProvider>
        </B2BAuthProvider>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
